export const piclist = [
  "virgin.jpg",
  "abide.png",
  "gospel.png",
  "light500.jpg",
  "corpus1.jpg",
  "corpus4.jpg",
  "corpus5.jpg",
  "easter1.jpg",
  "tyler1.png",
  "tyler2.png",
  "palms.jpg",
  "shelve.jpg",
  "altar.jpg",
  "xm8.jpg",
  "party.jpg",
  "mary.jpg",
  "leo_crop.jpg",
  "guadalupe.jpg",
  "smlinda2.jpg",
  "smMaria3.jpg"
]

